/*jshint esversion: 6 */
$('.responsive-table').each(function (tableIndex) {
    var tableClass = 'editor-styles-' + tableIndex;
    $(this).addClass(tableClass);

    var headerLabels = $(this).find('th');
    var css = '<style>';

    headerLabels.each(function (labelIndex, labelCell) {

        var childIndex = labelIndex + 1;
        css += '.' + tableClass + ' .data-row td:nth-child(' + childIndex + ')::before {';
        css += 'content: "' + $(labelCell).html() + '";';
        css += '}';

    });

    css += "</style>";
    $(this).after($(css));
});
